import React, { useState, useEffect } from 'react';
import { Modal, Box, TextField, Button, Typography,FormControlLabel,Switch, IconButton} from '@mui/material';
import { ModalBox } from '../../../styles/ModalStyles';
import CloseIcon from '@mui/icons-material/Close';
const EditarTipoDocumentoModal = ({ open, onClose, onSubmit, documento }) => {
  const [nombre, setNombre] = useState('');
  const [habilitado, setHabilitado] = useState(false);

  useEffect(() => {
    if (documento) {
      setNombre(documento.nombre);
      setHabilitado(documento.habilitado);
    }
  }, [documento]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ ...documento, nombre, habilitado });
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox>
      <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant='h6'>Editar Tipo de Documento</Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Nombre"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            margin="normal"
            required
          />
          <FormControlLabel
            control={
              <Switch
                checked={habilitado}
                onChange={(e) => setHabilitado(e.target.checked)}
                color="primary"
              />
            }
            label={habilitado ? "Habilitado" : "Deshabilitado"}
          />
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <Button type="submit" variant="contained" color="primary" sx={{ mr: 1 }}>
              Guardar
            </Button>
            <Button onClick={onClose} variant="contained" color="error" >
              Cancelar
            </Button>
          </Box>
        </form>
      </ModalBox>
    </Modal>
  );
};

export default EditarTipoDocumentoModal;